import { useEffect } from "react";

export const APP_MAIN_SCROLL_ID = "app-main-scroll";

/**
 * Locks the app main scroll container while overlays (dialogs/drawers) are open.
 */
const useLockAppScroll = (locked) => {
  useEffect(() => {
    if (!locked) return undefined;

    const scrollRoot = document.getElementById(APP_MAIN_SCROLL_ID);
    const previousOverflow = scrollRoot?.style.overflow ?? "";

    if (scrollRoot) {
      scrollRoot.style.overflow = "hidden";
    }

    return () => {
      if (scrollRoot) {
        scrollRoot.style.overflow = previousOverflow;
      }
    };
  }, [locked]);
};

export default useLockAppScroll;
